const UPDATES = [
  {
    id: 1,
    date: '07-31',
    title: '香蕉视频最新都市情感大剧《夜上海》全集上线',
    desc: '由当红实力派演员主演的年度都市情感巨制，讲述上海滩的爱恨纠葛，画面精美剧情细腻，玫瑰视频全网首发。',
    tag: '新剧上线',
  },
  {
    id: 2,
    date: '07-30',
    title: '糖豆视频悬疑神作《无声的证词》加更8集',
    desc: '高口碑悬疑剧一次性加更八集，层层反转烧脑不停，观众直呼过瘾，玫瑰视频同步更新高清资源。',
    tag: '加更通知',
  },
  {
    id: 3,
    date: '07-29',
    title: '蓝莓视频经典古装《琅琊风云》4K修复版上线',
    desc: '经典古装巨制经过4K修复重新上线玫瑰视频，画质全面升级，服化道细节纤毫毕现，重温经典更尽兴。',
    tag: '经典回归',
  },
  {
    id: 4,
    date: '07-28',
    title: '小蓝视频高分电影《归途》独家登陆玫瑰视频',
    desc: '豆瓣8.8分高分文艺片独家上线，讲述乡村与城市之间的温情故事，影迷不容错过的走心佳作。',
    tag: '独家上线',
  },
  {
    id: 5,
    date: '07-27',
    title: '玫瑰视频播放技术升级，不缓冲体验再优化',
    desc: '全站播放引擎全面升级，加载速度提升40%，高清画质下真正实现秒开秒播，为用户带来极致流畅观影。',
    tag: '技术升级',
  },
  {
    id: 6,
    date: '07-26',
    title: '糖豆视频热门综艺《欢乐大咖秀》新季开播',
    desc: '人气综艺全新一季火热开播，明星阵容豪华升级，笑点密集精彩不断，玫瑰视频高清同步更新。',
    tag: '综艺上新',
  },
  {
    id: 7,
    date: '07-25',
    title: '香蕉视频年度大剧《江湖行》预告片首发',
    desc: '年度武侠巨制预告片震撼发布，顶级制作团队倾力打造，预计下月正式开播，玫瑰视频将全网同步上线。',
    tag: '即将上线',
  },
  {
    id: 8,
    date: '07-24',
    title: '玫瑰视频影视索引页全新改版，找片更便捷',
    desc: '影视索引功能全面优化，按平台、类型、评分多维度分类，配合搜索功能让你快速找到心仪好片。',
    tag: '功能更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-3">
            实时动态
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">最新动态</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            玫瑰视频及各大平台最新影视资讯速递
          </p>
        </div>

        <div className="space-y-5">
          {UPDATES.map((update) => (
            <article
              key={update.id}
              className="flex gap-4 md:gap-6 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-colors duration-200"
            >
              <div className="flex-shrink-0 flex flex-col items-center">
                <span className="text-xs font-bold text-primary-600 bg-primary-100 px-2 py-1 rounded-md whitespace-nowrap">
                  {update.date}
                </span>
                <div className="w-px flex-1 bg-background-200 mt-1"></div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug">{update.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {update.tag}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">{update.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}